export default __webpack_public_path__ + "static/media/gridloader.81da48ab.gif";